"use client";

import { kClientPaths } from "@/src/lib/clientHelpers/clientPaths.ts";
import { useAppSession } from "@/src/lib/clientHooks/userHooks.ts";
import { UserIcon } from "lucide-react";
import { signOut } from "next-auth/react";
import { useRouter } from "next/navigation";
import { Button } from "../ui/button.tsx";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu.tsx";

export function UserMenu() {
  const router = useRouter();
  const { status } = useAppSession();

  if (status !== "authenticated") {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger render={<Button variant="outline" size="icon" />}>
          <UserIcon />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-auto">
        <DropdownMenuItem
          onClick={() => {
            router.push(kClientPaths.app.index);
          }}
        >
          Go to App
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => {
            router.push(kClientPaths.app.profile);
          }}
        >
          Notification Preferences
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => {
            router.push(kClientPaths.docs.index);
          }}
        >
          Docs
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => {
            signOut({
              redirectTo: kClientPaths.index,
            });
          }}
        >
          Sign Out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
